import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ApiService } from '../services/api.service';
import { extractList } from '../shared/utils/extract-list';

interface Report {
  id: number | string;
  title: string;
  category: string;
  generatedDate: string;
  size: string;
  type: string;
}

@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss'
})
export class ReportsComponent implements OnInit {

  loading = false;
  searchText = '';
  error: string | null = null;

  reports: Report[] = [];
  filteredReports: Report[] = [];
  categories = ['All', 'HR', 'Attendance', 'Leaves', 'Payroll', 'Performance'];

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadReports();
  }

  loadReports(): void {
    this.loading = true;
    this.error = null;

    this.apiService.getReports().subscribe({
      next: (response) => {
        const data = extractList(response);
        this.reports = data.map((row: any, index: number) => ({
          id: row.id || index + 1,
          title: row.title || row.name || `Report ${index + 1}`,
          category: row.category || row.type || 'HR',
          generatedDate: String(row.generatedDate || row.createdAt || '').slice(0, 10) || '—',
          size: row.size || '—',
          type: row.format || row.fileType || row.type || 'PDF'
        }));
        this.filteredReports = [...this.reports];
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.error = err?.error?.message || err?.message || 'Failed to load reports.';
        this.reports = [];
        this.filteredReports = [];
      }
    });
  }

  filterReports(): void {
    const search = this.searchText.toLowerCase().trim();
    this.filteredReports = this.reports.filter(r =>
      r.title.toLowerCase().includes(search) ||
      r.category.toLowerCase().includes(search)
    );
  }

  downloadReport(report: Report): void {
    alert(`Downloading: ${report.title}`);
  }

  generateReport(): void {
    this.loadReports();
  }
}
